// Live is what a customer can see: Show Prepacks on a feed surface Design has
// not disabled.
export function isPrepackSurfaceLive(surface) {
  return surface?.prepacks_enabled === true && surface?.is_enabled !== false
}
